<div class="p-2 fill-column">
  <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">E-learning</div>
  <!-- for Dev only -->
  <!-- <video controls width="250">
  <source [src]="getVideoUrl('5e4a4470-d391-4b84-bf24-6b4bbff66f64.mp4')" type="video/mp4">
</video> -->
  <div class="main-card p-3 fill-column">
    <div class="flex align-items-center justify-content-end pb-1 gap-2">
      <p-splitButton
        [outlined]="true"
        icon="pi pi-plus"
        label="Dodaj nowy slajd"
        (onClick)="openAddElearningModal()"
        [model]="splitButtonItems"
      />
    </div>
    <p-tabView (onChange)="onTabChange($event)">
      <p-tabPanel header="Slajdy">
        <app-content-list class="fill-column"></app-content-list>
      </p-tabPanel>
      <p-tabPanel header="Rozdziały wykładów">
        <app-topic-list class="fill-column"></app-topic-list>
      </p-tabPanel>
      <p-tabPanel header="Działy wykładów">
        <app-category-list class="fill-column"></app-category-list>
      </p-tabPanel>
      <p-tabPanel header="Podgląd">
        <app-overview-list></app-overview-list>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
